import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons';
import QuestionPreviewTypes from '../../../enums/questionPreviewTypes';

function AssignmentPreviewHeader({assignmentName,numberOfQuestions,courseName,verificationNumber,type, createdDate}){
  const navigate = useNavigate();
  return (
    <>   
      {type == QuestionPreviewTypes.editAssignmentPreview && <div className='d-flex justify-content-md-end mb-3'>
        <button
          onClick={() => navigate('/assignments')}
          className="btn btn-castleWhite mr-3 btn-width">
              Back
        </button>
      </div>
      }
      
      <div className="row assignment-review-header">
        <div className="col-lg-6">
          <p>
              Assignment: <strong>{assignmentName}</strong>
          </p>
        </div>
        <div className="col-lg-6">
          <p className="text-lg-end">
              Number of questions:{' '}
            <span className="d-inline-block badge">{numberOfQuestions}</span>
          </p>
        </div>
        <div className="col-lg-6">
          <p>
              Course: <strong>{courseName}</strong> <span className='m-4'>Created: <strong>{createdDate}</strong></span>
          </p>
        </div>
        <div className="col-lg-6">
          <p className="text-lg-end">
            {' '}
              Verification Number: <strong className='m-1'>{verificationNumber}</strong>
            <OverlayTrigger
              placement="left"
              overlay={
                <Tooltip className="initial-assignment-tooltip">
                    The <b>Verification Number</b> helps you confirm that all students in your class are working on the proper assignment while you are monitoring them in a computer classroom environment.
                  <br></br><br></br>The number, which is the same for all students working on the assignment, is displayed large enough to view from a reasonable distance on a student&apos;s screen. In addition, the background color of the information area will also match the other students working on the same assignment.
                </Tooltip>
              }>
              <FontAwesomeIcon className='circle-question' icon={faQuestionCircle} />
            </OverlayTrigger>
          </p>
        </div>
      </div>
    </>
  );
}

AssignmentPreviewHeader.propTypes =
{
  assignmentName : PropTypes.string.isRequired,
  courseName : PropTypes.string.isRequired,
  numberOfQuestions: PropTypes.string,
  verificationNumber : PropTypes.string,
  previewType : PropTypes.string,
  createdDate : PropTypes.string
};
export default AssignmentPreviewHeader;